import { render, staticRenderFns } from "./HeaderAcolhimento.vue?vue&type=template&id=480db89d"
import script from "./HeaderAcolhimento.vue?vue&type=script&lang=js"
export * from "./HeaderAcolhimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports